<template>
  <div class="ml-2">
    <!-- Row with caret + icon + name -->
    <div class="row">
      <!-- caret toggle icon -->
      <v-icon
        small
        class="caret"
        v-if="node.type === 'folder'"
        @click.stop="toggle" 
      >
        {{ expanded ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
      </v-icon>
      <span v-else class="caret-placeholder"></span>

      <!-- folder/file icon + name -->
      <div
        class="name"
        :class="{ active: isSelected }"
        @click="selectNode"
      >
        <v-icon small class="fileicon">
          <!-- yellow folder if folder, gray file otherwise -->
          {{ node.type === 'folder' ? 'mdi-folder' : 'mdi-file' }}
        </v-icon>
        {{ node.name }}
      </div>
    </div>

    <!-- children -->
    <div v-if="expanded" class="children">
      <TreeNode
        v-for="child in node.children"
        :key="child.id"
        :node="child"
        :selected-id="selectedId"
        @select-folder="$emit('select-folder', $event)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    node: { type: Object, required: true },
    selectedId: [String, Number] // pass down the active node id
  },
  data () {
    return { expanded: false }
  },
  computed: {
    isSelected () {
      return this.selectedId === this.node.id
    }
  },
  methods: {
    toggle () {
      if (this.node.type === 'folder') {
        this.expanded = !this.expanded
      }
    },
    selectNode () {
      this.$emit('select-folder', this.node)
    }
  }
}
</script>

<style scoped>
.row {
  display: flex;
  align-items: center;
  padding: 2px 0;
}

.caret {
  cursor: pointer;
  margin-right: 4px;
}
.caret-placeholder {
  display: inline-block;
  width: 24px; /* same width as caret icon */
  margin-right: 4px;
}

.name {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 4px;
}
.name:hover {
  background-color: #e6f2ff;
}
.name.active {
  font-weight: bold;
  background-color: #dbeafe; /* highlight bg */
}

.fileicon {
  margin-right: 6px;
  color: #fbc02d; /* yellow for folders by default */
}
.name.active .fileicon {
  color: #f9a825; /* darker yellow when active */
}

.children {
  margin-left: 16px;
}
</style>
